import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import Home from "./pages/Home";
import GreenEnergy from "./pages/Green-Energy/GreenEnergy";
import GreenEnergyAbout from "./pages/Green-Energy/About";
import GreenEnergyProject from "./pages/Green-Energy/Project";
import GreenEnergyServices from "./pages/Green-Energy/Services";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Promoters from "./pages/Developers/Promoters";
import DevelopersAbout from "./pages/Developers/About";
import DevelopersProject from "./pages/Developers/Project";
import DevelopersServices from "./pages/Developers/Services";

import TermsConditions from "./pages/terms";
import PrivacyPolicy from "./pages/privacypolicy";

import FloatingButtons from "./components/FloatingButtons";
import ScrollToTop from "./components/ScrollToTop";
import PageLoaderCM from "./components/PageLoaderCM";

/* ADMIN */
import ProtectedAdminRoute from "./pages/Admin/ProtectedAdminRoute";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/Dashboard";

import "./App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageLoaderCM />

      <div className="App">
        <Routes>
          {/* ===== PUBLIC ROUTES ===== */}
          <Route path="/" element={<Home />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/policy" element={<PrivacyPolicy />} />

          <Route path="/green-energy/greenenergy" element={<GreenEnergy />} />
          <Route path="/green-energy/about" element={<GreenEnergyAbout />} />
          <Route path="/green-energy/project" element={<GreenEnergyProject />} />
          <Route path="/green-energy/services" element={<GreenEnergyServices />} />

          <Route path="/developers/promoters" element={<Promoters />} />
          <Route path="/developers/about" element={<DevelopersAbout />} />
          <Route path="/developers/project" element={<DevelopersProject />} />
          <Route path="/developers/services" element={<DevelopersServices />} />

          {/* ===== ADMIN ROUTES ===== */}
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route path="/admin" element={<ProtectedAdminRoute />}>
            <Route>
              <Route path="dashboard" element={<AdminDashboard />} />
            </Route>
          </Route>
        </Routes>
      </div>

      {/* FLOATING BUTTONS – GLOBAL (optional) */}
      <FloatingButtons />
    </Router>
  );
}

export default App;
